export default {
      id: "vague_alu-usage",
      viewBox: "0 0 2000 140",
      url: "../dist/images/" + "sprite.svg#vague_alu-usage",
      toString: function () {
        return this.url;
      }
    }